import { ChangeDetectionStrategy, Component, HostBinding, Injector, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '@fi-app/data-field/data-field-edit/data-field-edit-base';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';

@Component({
    selector: 'data-field-edit-org-nr',
    template: `
        <div class="form-group full-width-material">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'business_unit.org_nr' | fiAppText }}</mat-label>
                <input matInput type="text" disabled [(ngModel)]="dataFieldObject.OrganisationNumber" />
            </mat-form-field>
        </div>
    `,
    styleUrls: ['./org-nr.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-edit-org-nr' },
    standalone: false,
})
export class FiDataFieldEditOrgNrComponent extends DataFieldEditBase {
    constructor(
        injector: Injector,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
    ) {
        super(injector);
    }

    @HostBinding('class.hidden')
    get hidden(): boolean {
        return !this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.Personalkollen,
            AccessRightType.Read,
        );
    }
}
